class WaitlistForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.field__input');
    this.button = this.querySelector('.field__button');
    this.message = this.querySelector('.waitlist-form__message');
    this.button?.addEventListener('click', this.onSubmit.bind(this));
    this.input?.addEventListener('keydown', (e) => { if (e.key === 'Enter') this.onSubmit(e); });
  }

  async onSubmit(event) {
    event.preventDefault();
    const email = this.input.value.trim();
    if (!email) return;
    this.button.disabled = true;
    this.showMessage('', false);
    try {
      const res = await fetch(this.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          productId: this.querySelector('.waitlist-form__product-id').value,
          productTitle: this.querySelector('.waitlist-form__product-title').value,
          variantId: this.querySelector('.waitlist-form__variant-id').value,
          variantTitle: this.querySelector('.waitlist-form__variant-title').value,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        this.querySelector('.waitlist-form__prompt').innerHTML =
          "<p class=\"waitlist-form__success\">You're on the list! We'll email you the moment this is back.</p>";
      } else {
        this.showMessage('Something went wrong. Please try again in a moment.', true);
        this.button.disabled = false;
      }
    } catch {
      this.showMessage('Something went wrong. Please try again in a moment.', true);
      this.button.disabled = false;
    }
  }

  showMessage(text, isError) {
    if (!this.message) return;
    this.message.textContent = text;
    this.message.hidden = !text;
    this.message.classList.toggle('waitlist-form__message--error', isError);
  }
}
customElements.define('waitlist-form', WaitlistForm);
